import o from"styled-components";const e=o.div`
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 24px;
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	background-color: ${({backgroundColor:o})=>o};
	color: ${({color:o})=>o};
	border-radius: ${({borderRadius:o})=>`${o}px`};
	box-sizing: border-box;
	height: 100%;
`,i=o.div`
	width: ${({isFiveColumn:o})=>o?"32px":"48px"};
	height: ${({isFiveColumn:o})=>o?"32px":"48px"};
	display: grid;
	place-content: center;
	border-radius: ${({isFiveColumn:o})=>o?"9.33px":"14px"};
	background-color: ${({backgroundColor:o})=>o};

	color: ${({color:o})=>o};
	font-size: ${({isFiveColumn:o})=>o?"14px":"18px"};
	font-style: normal;
	font-weight: 600;
	line-height: 100%;
`,t=o.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	flex: 1;
`,l=o.h1`
	all: unset;
	font-size: ${({isFiveColumn:o})=>o?"16px":"22px"};
	font-style: normal;
	font-weight: 600;
	line-height: 25.887px;
	min-height: 25.887px;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,n=o.p`
	all: unset;
	font-size: 14px;
	opacity: 0.8;
	font-style: normal;
	font-weight: 500;
	line-height: 18px;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,r=o.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`,p=o.span`
	color: ${({color:o})=>o};
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	cursor: ${({isEditable:o=!1})=>o?"text":"default"};
`,d=o.div`
	display: grid;
	place-content: center;
	padding: 5px;
	border-radius: 50%;
	background-color: ${({color:o})=>o};
`;export{d as ArrowContainer,r as CallToActionContainer,e as CardContainer,t as CardContentContainer,l as CardHeading,p as CardLabel,n as CardParagraph,i as CardStep};
